import { createFileRoute } from '@tanstack/react-router';

import {
  parseListRouteSearch,
  type ListRouteSearch,
} from '../../hooks/use-list-table-helpers/index.js';
import { RouteGuard } from '../../lib/route-guard.js';
import { PickingListPage } from '../../modules/picking/picking-list-page.js';

/** `pick` opens that order's pick screen in a drawer over the list, e.g. "work-order/<id>". */
type PickingListRouteSearch = ListRouteSearch & { pick?: string };

export const Route = createFileRoute('/picking/')({
  validateSearch: (search: Record<string, unknown>): PickingListRouteSearch => ({
    ...parseListRouteSearch(search),
    ...(typeof search.pick === 'string' && { pick: search.pick }),
  }),
  component: () => (
    <RouteGuard route="/picking/">
      <PickingListPage />
    </RouteGuard>
  ),
});
